<script setup lang="ts">
import { RouterLink } from 'vue-router'
import LogoMark from '@/components/public/LogoMark.vue'

interface FooterLink {
  label: string
  to?: string
  href?: string
}

const productLinks: FooterLink[] = [
  { label: 'Features', href: '/#features' },
  { label: 'Integrations', to: '/integrations' },
  { label: 'Pricing', to: '/pricing' },
  { label: 'Changelog' },
]
const companyLinks: FooterLink[] = [
  { label: 'About' },
  { label: 'Careers' },
  { label: 'Contact us', to: '/contact-us' },
  { label: 'Affiliate' },
]
const resourceLinks: FooterLink[] = [
  { label: 'Support docs', to: '/support-docs' },
  { label: 'Community' },
  { label: 'Status', to: '/status' },
  { label: 'Feature requests', to: '/feature-requests' },
]
const legalLinks: FooterLink[] = [{ label: 'Privacy Policy' }, { label: 'Terms of Service' }, { label: 'Cookie Policy' }]
</script>

<template>
  <footer class="bg-neutral-950 text-neutral-300">
    <div class="mx-auto max-w-7xl px-6 py-16 lg:px-8">
      <div class="grid grid-cols-1 gap-12 md:grid-cols-[1.4fr_1fr_1fr_1fr]">
        <div class="max-w-xs">
          <LogoMark variant="light" class="h-6 w-auto" />
          <p class="mt-4 text-sm text-neutral-400">
            The campaign workspace for creatives, from first draft to closing night.
          </p>
        </div>

        <div>
          <h3 class="text-sm font-semibold text-white">Product</h3>
          <ul class="mt-4 space-y-3 text-sm">
            <li v-for="l in productLinks" :key="l.label">
              <a v-if="l.href" :href="l.href" class="hover:text-white">{{ l.label }}</a>
              <RouterLink v-else-if="l.to" :to="l.to" class="hover:text-white">{{ l.label }}</RouterLink>
              <span v-else class="cursor-default text-neutral-500">{{ l.label }}</span>
            </li>
          </ul>
        </div>

        <div>
          <h3 class="text-sm font-semibold text-white">Company</h3>
          <ul class="mt-4 space-y-3 text-sm">
            <li v-for="l in companyLinks" :key="l.label">
              <RouterLink v-if="l.to" :to="l.to" class="hover:text-white">{{ l.label }}</RouterLink>
              <span v-else class="cursor-default text-neutral-500">{{ l.label }}</span>
            </li>
          </ul>
        </div>

        <div>
          <h3 class="text-sm font-semibold text-white">Resources</h3>
          <ul class="mt-4 space-y-3 text-sm">
            <li v-for="l in resourceLinks" :key="l.label">
              <RouterLink v-if="l.to" :to="l.to" class="hover:text-white">{{ l.label }}</RouterLink>
              <span v-else class="cursor-default text-neutral-500">{{ l.label }}</span>
            </li>
          </ul>
        </div>
      </div>

      <div class="mt-12 flex flex-col gap-4 border-t border-neutral-800 pt-8 text-xs text-neutral-500 sm:flex-row sm:items-center sm:justify-between">
        <p>© {{ new Date().getFullYear() }} Kantiro. All rights reserved.</p>
        <div class="flex gap-6">
          <span v-for="l in legalLinks" :key="l.label" class="cursor-default hover:text-neutral-300">{{ l.label }}</span>
        </div>
      </div>
    </div>
  </footer>
</template>
